import { useMyContext } from "../context";
import { useTranslation } from "react-i18next";

const EmployeeInfoButtons = () => {
  const { t } = useTranslation();
  const { handleOpenModal, setMode } = useMyContext();
  const openEdit = () => {
    setMode("update");
    handleOpenModal("addEditEmployee");
  };
  return (
    <div className=" w-full md:w-auto flex md:flex-row flex-col gap-4 ">
      <button
        onClick={openEdit}
        className="md:w-[200px] w-full h-[50px] rounded-xl bg-secondary text-white flex items-center justify-center gap-3 cursor-pointer"
      >
        <img src="/img/edit.svg" alt="" className="w-5 h-5" />
        {t("admin.editEmployee")}
      </button>
      <button
        onClick={() => handleOpenModal("delete")}
        className="md:w-[200px] w-full h-[50px] rounded-xl bg-bg10 text-white flex items-center justify-center gap-3 cursor-pointer"
      >
        <img src="/img/delete2.svg" alt="" />
        {t("admin.deleteEmployee")}
      </button>
    </div>
  );
};

export default EmployeeInfoButtons;
